import { render } from "./WrappedView.vue?vue&type=template&id=f7af8a3e&scoped=true"
const script = {}

import "./WrappedView.vue?vue&type=style&index=0&id=f7af8a3e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lumaa.fr/lumaa.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7af8a3e"]])

export default __exports__